"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _DateiBase = _interopRequireDefault(require("./DateiBase"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The RentalPackageCreate model module.
 * @module model/RentalPackageCreate
 * @version 0.0.1
 */
class RentalPackageCreate {
  /**
   * Constructs a new <code>RentalPackageCreate</code>.
   * @alias module:model/RentalPackageCreate
   * @param name {String} 
   * @param beschreibung {String} 
   * @param preis {Number} 
   */
  constructor(name, beschreibung, preis) {
    RentalPackageCreate.initialize(this, name, beschreibung, preis);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, name, beschreibung, preis) {
    obj['name'] = name;
    obj['beschreibung'] = beschreibung;
    obj['preis'] = preis;
  }

  /**
   * Constructs a <code>RentalPackageCreate</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RentalPackageCreate} obj Optional instance to populate.
   * @return {module:model/RentalPackageCreate} The populated <code>RentalPackageCreate</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new RentalPackageCreate();
      if (data.hasOwnProperty('name')) {
        obj['name'] = _ApiClient.default.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('beschreibung')) {
        obj['beschreibung'] = _ApiClient.default.convertToType(data['beschreibung'], 'String');
      }
      if (data.hasOwnProperty('bild')) {
        obj['bild'] = _DateiBase.default.constructFromObject(data['bild']);
      }
      if (data.hasOwnProperty('items')) {
        obj['items'] = _ApiClient.default.convertToType(data['items'], ['Number']);
      }
      if (data.hasOwnProperty('preis')) {
        obj['preis'] = _ApiClient.default.convertToType(data['preis'], 'Number');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>RentalPackageCreate</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>RentalPackageCreate</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of RentalPackageCreate.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
      throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
    }
    // ensure the json data is a string
    if (data['beschreibung'] && !(typeof data['beschreibung'] === 'string' || data['beschreibung'] instanceof String)) {
      throw new Error("Expected the field `beschreibung` to be a primitive type in the JSON string but got " + data['beschreibung']);
    }
    // validate the optional field `bild`
    if (data['bild']) {
      // data not null
      _DateiBase.default.validateJSON(data['bild']);
    }
    // ensure the json data is an array
    if (!Array.isArray(data['items'])) {
      throw new Error("Expected the field `items` to be an array in the JSON data but got " + data['items']);
    }
    return true;
  }
}
RentalPackageCreate.RequiredProperties = ["name", "beschreibung", "preis"];

/**
 * @member {String} name
 */
RentalPackageCreate.prototype['name'] = undefined;

/**
 * @member {String} beschreibung
 */
RentalPackageCreate.prototype['beschreibung'] = undefined;

/**
 * @member {module:model/DateiBase} bild
 */
RentalPackageCreate.prototype['bild'] = undefined;

/**
 * @member {Array.<Number>} items
 */
RentalPackageCreate.prototype['items'] = undefined;

/**
 * @member {Number} preis
 */
RentalPackageCreate.prototype['preis'] = undefined;
var _default = exports.default = RentalPackageCreate;